import { useAutoAnimate } from "@formkit/auto-animate/react"
import React from "react"

interface CheckboxProps {
	props?: any
	className?: string | null
	label?: any
	errMsg?: string
	hasError?: boolean
}

const ElemCheckboxMafo: React.FC<CheckboxProps> = ({ className, props, label, errMsg, hasError }) => {
	const [animationRef] = useAutoAnimate<HTMLDivElement>()
	return (
		<label className={"relative block cursor-pointer " + (className || "")}>
			<div className=" p-1 md:p-1">
				<input className={"peer absolute hidden h-1 w-1 " + (hasError ? " js-formerror " : "")} {...props} />
				<span className=" bg-white peer-checked:hidden">
					<p className="font-Alpro bg-blue/20 p-4 px-8 text-center text-[18px] text-blue md:text-[24px]">{label}</p>
				</span>
				<span className="hidden  peer-checked:block">
					<p className="font-Alpro bg-blue p-4 px-8  text-center text-[18px] text-white md:text-[24px]">{label}</p>
				</span>
				<div>
					<div ref={animationRef}>{hasError && <div className="formErrorMsg js-formerror pl-2 pt-2 font-bold text-red">{errMsg}</div>}</div>
				</div>
			</div>
		</label>
	)
}

export default ElemCheckboxMafo
